module.exports = __webpack_public_path__ + "img/team9.71116a08.jpg";